import { useState } from "react";
import { useUser } from "@auth";
import { ActivityItem } from "./ActivityPanel";
import TaskFilters from "./TaskFilters";
import { ACTIVITY_FILTERS } from "../hooks/activityFilters";
import { useActivityDetail } from "../hooks/useActivityDetail";

// The merchant-wide activity feed at full width. Pills filter the pages already loaded; "Load more"
// pulls the next page, so a sparse pill can always reach further back.
const ActivityTab = ({ feed }) => {
  const { user } = useUser();
  const { items, fetchNextPage, hasNextPage, isFetchingNextPage } = feed;
  const { onSelect, modals } = useActivityDetail();
  const [active, setActive] = useState("all");

  const activeDef = ACTIVITY_FILTERS.find((f) => f.key === active) ?? ACTIVITY_FILTERS[0];
  const visible = activeDef.select(items, user?.guid);

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-between gap-4">
        <TaskFilters
          filters={ACTIVITY_FILTERS}
          active={active}
          onChange={setActive}
          label="Activity filters"
        />
        <span className="flex items-center gap-2 text-[13px] font-medium text-zinc-500">
          Live across all accounts
          <span className="size-1.5 rounded-full bg-green-600" />
        </span>
      </div>

      <div className="rounded-2xl border border-zinc-200 bg-white px-6">
        {visible.length === 0 ? (
          <p className="py-8 text-center text-sm text-zinc-500">
            {items.length === 0 ? "Waiting for activity…" : "Nothing here in the loaded activity."}
          </p>
        ) : (
          <ul className="flex flex-col divide-y divide-zinc-100 [&>li]:py-4">
            {visible.map((item) => (
              <ActivityItem key={item.id} item={item} isLast onSelect={onSelect} />
            ))}
          </ul>
        )}
        {hasNextPage && (
          <div className="flex justify-center border-t border-zinc-100 py-3">
            <button
              type="button"
              disabled={isFetchingNextPage}
              onClick={() => fetchNextPage()}
              className="text-[13px] font-semibold text-zinc-700 hover:text-zinc-900 disabled:text-zinc-400"
            >
              {isFetchingNextPage ? "Loading…" : "Load more"}
            </button>
          </div>
        )}
      </div>

      {modals}
    </div>
  );
};

export default ActivityTab;
